'use client';

import React, { useEffect } from 'react';

export const AppHeight = () => {

  useEffect(() => {
    const { innerHeight } = window;

    const onResize = () => {
      document.documentElement.style.setProperty('--app-height', `${innerHeight}px`);
    };

    window.addEventListener('resize', onResize);

    onResize();

    return () => window.removeEventListener('resize', onResize);
  }, []);

  return <></>;
};